// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__QN8yx","errorLogs":"EditorFooter_errorLogs__3ahSZ"};